export interface CompanyDetailDisplayNameInput {
    companyId: string;
    navigatedCompanyLabel?: string;
    organizationDisplayName?: string;
    organizationName?: string;
    adminCompanyName?: string;
}

export function getCompanyDetailDisplayName({
    adminCompanyName,
    companyId,
    navigatedCompanyLabel,
    organizationDisplayName,
    organizationName,
}: CompanyDetailDisplayNameInput): string {
    return (
        adminCompanyName?.trim() ||
        navigatedCompanyLabel?.trim() ||
        organizationDisplayName?.trim() ||
        organizationName?.trim() ||
        `Company ${companyId}`
    );
}
